import { Helpers } from '../../helpers';
import { IPadDesign } from '../../interfaces/ipad-design';
import { Pad } from '../pad';

export class PadDesignBase {
  PadDesignId: number;
  Name: string;
  Description: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Pads_PadDesign?: Array<Pad> | null;

  constructor(item?: IPadDesign) {
    if (item) {

      this.PadDesignId = item.PadDesignId;
      this.Name = item.Name;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Pads_PadDesign = Helpers.createClassArray(Pad, item.Pads_PadDesign);
    }
  }
}